let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("kTnVa"), load("10PAX")]).then(() => parcelRequire('e8df7'));